export default __webpack_public_path__ + "static/media/captacao-investimentos.d6f869a3.png";